import Vue from "vue";
import Vuex from "vuex";
import cognito from "@/store/cognito";
import organization from "@/store/organization";
import registration from "@/store/registration";
import role from "@/store/role";
import feature from "@/store/feature";
import signedUrl from "@/utils/signedUrl";
import signin from "@/store/signin";
import statics from "@/store/static";
import user from "@/store/user";

Vue.use(Vuex);

// plugins
const init = store => {
  store.dispatch("cognito/initialize");
  store.dispatch("user/initialize");
};

const mutations = store => {
  store.subscribe(mutation => {
    switch (mutation.type) {
      case "cognito/signIn":
      case "cognito/signOut":
        store.dispatch("user/initialize");
        break;
      case "user/setInitialized":
      case "user/setUser":
        store.dispatch("feature/initialize");
        store.dispatch("role/initialize");
        store.dispatch("organization/initialize");
        break;
    }
  });
};

const fullstory = store => {
  store.subscribe(mutation => {
    if (mutation.type === "user/setUser") {
      if (!mutation.payload) return;
      // reference: https://help.fullstory.com/hc/en-us/articles/360020623294-FS-setUserVars-Recording-custom-user-data
      Vue.prototype.$FullStory.identify(mutation.payload.id, {
        displayName: mutation.payload.fullName,
        email: mutation.payload.emailAddress,
      });
    }
    if (mutation.type === "organization/setOrganizations") {
      if (!mutation.payload) return;
      // reference: https://help.fullstory.com/hc/en-us/articles/360020623294-FS-setUserVars-Recording-custom-user-data
      Vue.prototype.$FullStory.setUserVars({
        OrganizationIds_strs: mutation.payload.map(o => o.id),
        OrganizationDisplayNames_strs: mutation.payload.map(o => o.displayName),
        OrganizationLegalNames_strs: mutation.payload.map(o => o.legalName),
      });
    }
    if (mutation.type === "cognito/signOut") {
      // reference: https://developer.fullstory.com/anonymize
      Vue.prototype.$FullStory.anonymize();
    }
  });
};

export default new Vuex.Store({
  plugins: [init, mutations, fullstory],
  getters: {
    isInitialized(state) {
      return (
        state.cognito.isInitialized && state.user.isInitialized && state.role.isInitialized && state.feature.isInitialized && state.organization.isInitialized
      );
    },
    isAuthenticated(_, getters) {
      var isCognito = getters["cognito/isAuthenticated"];
      var isSignedUrl = signedUrl.isSignedUrl();
      return isCognito || isSignedUrl;
    },
    userId(_, getters) {
      var cognitoUserId = getters["cognito/userId"];
      var signedUrlUserId = signedUrl.getUserId();
      return cognitoUserId || signedUrlUserId;
    },
  },
  modules: {
    cognito,
    organization,
    registration,
    role,
    feature,
    signin,
    static: statics,
    user,
  },
});
